import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_AES_SECRET_KEY;
const IV = import.meta.env.VITE_AES_IV;

const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
const iv = CryptoJS.enc.Utf8.parse(IV);

export const encryptPayload = <T>(data: T): string => {
  const jsonData = JSON.stringify(data);

  const encrypted = CryptoJS.AES.encrypt(jsonData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};

export const decryptPayload = <T>(cipherText: string): T => {
  const bytes = CryptoJS.AES.decrypt(cipherText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // add fallback "{}" for in case we get empty response from backend
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8) || "{}";
  return JSON.parse(decryptedData) as T;
};
